/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TicketEditComponent, setupFormForTask } from '../ticket-edit.component';
import { TicketEditService } from '../../ticket-edit.service';
import { UntypedFormBuilder } from '@angular/forms';
import { PlanState } from 'src/app/services/plan-state.service';
import { ConstraintAcceptanceService } from 'src/app/modules/ticket-edit/constraint-acceptance.service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import * as strings from '@touchplan/strings';

@Component({
	selector: 'multi-edit-task',
	templateUrl: './multi-edit-task.component.html',
	styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiEditTaskComponent extends TicketEditComponent implements OnInit {
	public appStrings = strings;
	constructor(
		public planState: PlanState,
		public ticketEditService: TicketEditService,
		protected formBuilder: UntypedFormBuilder,
		protected cd: ChangeDetectorRef,
		protected constraintAcceptanceService: ConstraintAcceptanceService,
		protected planAccessCheck: PlanAccessCheck,
		protected featureFlagManager: FeatureFlagManager
	) {
		super(
			ticketEditService,
			formBuilder,
			planState,
			cd,
			constraintAcceptanceService,
			planAccessCheck,
			featureFlagManager
		);
		setupFormForTask(this.editForm);
	}

	public ngOnInit() {
		super.ngOnInit();
	}
}
